import React from 'react';
import PropTypes from 'prop-types';

const DislikeInstructions = ({ className }) => (
  <svg
    width="46px"
    height="100px"
    viewBox="0 0 46 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="02_how-it-works-over-version_02"
        transform="translate(-20.000000, -280.000000)"
      >
        <g id="Group-8" transform="translate(19.000000, 280.000000)">
          <g id="nope" transform="translate(1.000000, 0.000000)">
            <g
              id="Group-6-Copy-2"
              transform="translate(21.500000, 38.000000) scale(-1, 1) translate(-21.500000, -38.000000) "
              fill="#FFFFFF"
              fillRule="nonzero"
            >
              <path
                d="M42.3970294,27.478021 C42.4,26.2589635 41.4315804,25.2703745 40.2344237,25.2703745 C40.0650988,25.2703745 39.9017152,25.2855369 39.750214,25.3279916 C37.5311667,25.8435135 35.5467978,26.986759 33.9931676,28.5697144 C31.845415,30.7621985 30.5175514,33.7916476 30.5175514,37.1364747 L30.520522,40.1719888 L10.5342434,19.769453 C8.22310712,17.4101823 4.44151784,17.4101823 2.13335219,19.769453 C-0.177784065,22.1287236 -0.177784065,25.9890726 2.13335219,28.3453108 L11.3749266,37.7793608 C9.66682463,37.6004444 7.89931039,38.1553885 6.58927043,39.4896804 C5.68026311,40.4176198 5.1396117,41.5790602 4.94652191,42.7829554 L1.13522651,57.3631266 C0.612398769,59.3797268 1.11740284,61.6146657 2.66212116,63.1945886 L9.57176504,70.2481406 C17.0844432,77.9172865 29.2580118,77.9172865 36.77069,70.2481406 C40.4096899,66.5333508 42.2692931,61.7026077 42.3792057,56.8385073 L42.4,56.8567022 L42.4,56.3806026 C42.4,56.3715051 42.4,56.3624077 42.4,56.3593752 L42.3970294,27.478021 Z M39.3747803,56.7489896 C39.2739524,61.0356311 37.5924993,65.0558712 34.6418012,68.0649967 C28.3104037,74.5282591 18.0140982,74.5282591 11.6856663,68.0649967 L4.78785334,61.023522 C4.04943743,60.269727 3.77364353,59.1859574 4.0464719,58.1233789 L7.89572434,43.2836072 C7.96689696,42.841623 8.16558719,42.1968104 8.70531287,41.6428165 C9.54455666,40.7860936 10.555801,40.7497661 11.0866301,40.8042574 L15.2294696,41.2311051 C15.85223,41.2946782 16.4483006,40.9525945 16.7181635,40.3743823 C16.9880263,39.79617 16.8694053,39.1089754 16.427542,38.654882 L4.25998976,26.2339144 C3.10343471,25.0532716 3.10343471,23.130943 4.25998976,21.9533275 C5.4165448,20.7726847 7.29965366,20.7726847 8.45324318,21.9533275 L29.4165448,43.3532349 C30.3091681,44.2644489 31.6169649,44.4551681 32.7023473,43.9586927 C33.1679349,43.7437552 33.467453,43.2714981 33.467453,42.7508043 L33.467453,37.1563739 C33.467453,34.7345425 34.392697,32.458021 36.0682191,30.7445753 C37.0142218,29.7788701 38.1470526,29.0492934 39.3925735,28.5982273 L39.3747803,56.7489896 Z"
                id="Shape"
                transform="translate(21.400000, 47.000000) scale(-1, 1) translate(-21.400000, -47.000000) "
              />
              <polygon
                id="Path"
                transform="translate(20.900000, 9.500000) rotate(-180.000000) translate(-20.900000, -9.500000) "
                points="31.4 7.92953076 16.142 7.92953076 21.572 2.22732548 19.451 0 10.4 9.50472558 19.439 19 21.56 16.7726745 16.142 11.0799204 31.4 11.0799204"
              />
            </g>
            <g
              transform="translate(18.000000, 52.000000)"
              id="Line-6"
              stroke="#FFFFFF"
              strokeLinecap="square"
              strokeWidth="3"
            >
              <line x1="10" y1="0" x2="0" y2="10" />
              <line x1="0" y1="0" x2="10" y2="10" />
            </g>
          </g>
          <text
            id="Dislike"
            fontFamily="GothamBold, Gotham"
            fontSize="14"
            fontWeight="bold"
            fill="#FFFFFF"
          >
            <tspan x="0" y="99">
              Dislike
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
);

DislikeInstructions.propTypes = {
  className: PropTypes.string
};

DislikeInstructions.defaultProps = {
  className: null
};

export default DislikeInstructions;
